<template>
    

  <div class="row">
    <h3>{{$t('rationdistributor_list')}}</h3>
    <loading :loadingText="`${$t('loading')}`" id="loadMe" :loadinSubText="`${$t('please_wait')}`"></loading>
  
      <!-- Modal -->
  <div class="modal fade" id="bsModal" tabindex="-1" role="dialog" aria-labelledby="bsModalLabel" data-toggle="modal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="bsModalLabel">{{$t('rationdistributor_form')}}</h4>
        </div>
        <div class="modal-body">
               <form action="">
                 
               	<div class="form-group">
<input type="text"  v-model="form.contactNumber" name="contactNumber"  class="form-control my-input" id="contactNumber" :placeholder="`${$t('contactNumber')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.name" name="name"  class="form-control my-input" id="name" :placeholder="`${$t('name')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.idNumber" name="idNumber"  class="form-control my-input" id="idNumber" :placeholder="`${$t('idNumber')}`">
</div>
   
               	<div class="form-group">

    <strong>{{$t('distributorType')}}</strong>
    <ul class="list-group">
      <li class="list-group-item" v-for="(s, i) in $t('distributorTypeData')" :key="i">
          <label>
          
          <input  
              type="radio" name="distributorType"
              v-model="form.distributorType"
              :value="i"/>
          {{s}}
          </label>
      </li>
    </ul>
    
</div>
	<div class="form-group">
<input type="text"  v-model="form.distributorOrgName" name="distributorOrgName"  class="form-control my-input" id="distributorOrgName" :placeholder="`${$t('distributorOrgName')}`">
</div>
	<div class="form-group">
   
 <select v-model="form.location" class="form-control" :placeholder="`${$t('locationName')}`" @change="updateDistrict"> 
       <option  value="">{{$t('locationName')}}</option>              
       <option v-for="(s, i) in locationNames" :key="i" :value="{lat:s.latitude,lng:s.longitude,district:s.district,state:s.state,name:s.locationName}">
          {{s.locationName}}
        </option>
      </select>
</div>
	<div class="form-group">
<input type="text"  v-model="form.ward_village" name="ward_village"  class="form-control my-input" id="ward_village" :placeholder="`${$t('ward_village')}`">
</div>
	<div class="form-group">
<input type="text"  v-model="form.city_union" name="city_union"  class="form-control my-input" id="city_union" :placeholder="`${$t('city_union')}`">
</div>
<div class="form-group" v-if="form._id">
  <select v-model="form.active" class="form-control" :placeholder="`${$t('activeLbl')}`">           
       <option v-for="(s, i) in $t('activeData')" :key="i" :value="i">
          {{s}}
          </option>
      </select>
</div>

                  <div v-if="loading">
                      <i class="fa fa-spin fa-spinner fa-3x"></i>
                  </div>   
                  <div class="text-center" v-else>
                     <button type="button" class="btn btn-success " @click="submit">{{$t('submit')}}</button>
                  </div>
                
                  <div class="alert alert-danger padding5" v-if="error.length>0">
                    
                    
                        <p v-for="(s, i) in error" :key="i">
                           
                            
                            {{$t(s)}}
                           
                        </p>
                     
                    
                    </div>
               
               </form>
        </div>
        <div class="modal-footer">
          
        </div>
      </div>
    </div>
  </div>
   
        <div class="box">
          <div class="box-header">
            
            <button class="btn btn-primary pull-right" @click="openFrom">{{$t('add_new')}}</button>
            
          </div>
           
          <!-- /.box-header -->
          <div class="box-body no-padding table-responsive">
       
          <div class="input-group">
            
<input type="text"  v-model="search.contactNumber" name="contactNumber"  class="input-group-text" :placeholder="`${$t('contactNumber')}`">


<input type="text"  v-model="search.name" name="name"  class="input-group-text" :placeholder="`${$t('name')}`">


<input type="text"  v-model="search.idNumber" name="idNumber"  class="input-group-text" :placeholder="`${$t('idNumber')}`">
<input type="text"  v-model="search.locationName" name="locationName"  class="input-group-text" :placeholder="`${$t('locationName')}`">
<input type="text"  v-model="search.district" name="district"  class="input-group-text" :placeholder="`${$t('district')}`">
<input type="text"  v-model="search.ward_village" name="ward_village"  class="input-group-text" :placeholder="`${$t('ward_village')}`">


<input type="text"  v-model="search.city_union" name="city_union"  class="input-group-text" :placeholder="`${$t('city_union')}`">



      <select v-model="search.active" class="input-group-select" :placeholder="`${$t('activeLbl')}`"> 
       <option  value="">{{$t('activeLbl')}}</option>              
       <option v-for="(s, i) in $t('activeData')" :key="i" :value="i">
          {{s}}
          </option>
      </select>
      

                
            <span class="pull-right">
             <button class='btn btn-sm btn-success padding5' @click="searchClick">{{$t('search')}}</button>
              <button class='btn btn-sm btn-success padding5' @click="clearClick">{{$t('clear')}}</button>
              </span>
          </div>
       
            <table class="table table-striped">
                    <tbody>
                        <tr>
                            <th style="width: 10px">#</th>
                            	<th>{{$t('contactNumber')}}</th>
	<th>{{$t('name')}}</th>
	<th>{{$t('idNumber')}}</th>
  <th>{{$t('locationName')}}</th>
	<th>{{$t('ward_village')}}</th>
	<th>{{$t('city_union')}}</th>
	<th>{{$t('district')}}</th>
	<th>{{$t('state')}}</th>
	<th>{{$t('enterBy')}}</th>
	<th>{{$t('active')}}</th>
                            <th>{{ $t('action') }} </th>
                        </tr>
                        <tr v-for="rationdistributor in rationdistributors" :key="rationdistributor.id">
                            <td></td>
                            	<td>
{{rationdistributor.contactNumber}}
</td>
	<td>
{{rationdistributor.name}}
</td>
	<td>
{{rationdistributor.location.name!=undefined?rationdistributor.location.district:''}}
</td>
	<td>
{{rationdistributor.idNumber}}
</td>
	<td>
{{rationdistributor.ward_village}}
</td>
	<td>
{{rationdistributor.city_union}}
</td>
	<td>
{{rationdistributor.location.district!=undefined?rationdistributor.location.district:''}}
</td>
	<td>
{{rationdistributor.location.state!=undefined?rationdistributor.location.state:''}}
</td>

	<td>
{{rationdistributor.enterBy}}
</td>
	<td>

      {{ $t('activeData')[[rationdistributor.active]] }}
      
</td>
                        <td><a href="#" @click="openFrom(rationdistributor)"><i class="fa fa-edit fa-2x"></i></a></td>
                    </tr>
            </tbody>
            </table>
            <div class="card-footer pb-0 pt-3">
            <simple-pagination :currentpage="search.page" :pages="search.totalpages" @changePage="pageChange"></simple-pagination>
           </div>
        </div>
    </div>
 </div>

</template>

<script>
import { services } from '../../src/vuex/api'
import { mapActions , mapGetters } from 'vuex'
import simplePagination from '../../src/components/simple-pagination'
import VALoading  from '../../src/widgets/VALoading'
import { listError } from '../../src/lib/functions'
export default {
  name: 'RationDistributor',
   mounted: function () {
      var self = this
      let uri = window.location.href.split('?')
      if (uri.length === 2){
      let vars = uri[1].split('&')
      let getVars = {}
      let tmp = ''
      vars.forEach(function(v){
        tmp = v.split('=')
        if ( tmp.length === 2 ) {
          getVars[tmp[0]] = tmp[1]
          if ( tmp[0] in self.form ){
            self.form[tmp[0]] = tmp[1]
           }
         }
       })
      }
      this.getRationDistributor(self.form)
      this.getLanguage()
      
      if ( localStorage.getItem('lan') != null ) this.$i18n.locale = JSON.parse(localStorage.getItem('lan')).language
      console.log('mounted: got here')
    },
    created:function(){
       this.getLocations()
    },
    data: function () {
      return {
        loading:false,
        message: 'RationDistributor list',
        error:[],
        rationdistributors: [],
        locationNames:[],
        form: {
          contactNumber:'',
          name:'',
          idNumber:'',
          ward_village:'',
          city_union:'',
          active:1,
          location:{}
        },
        search:{
          contactNumber:'',
          name:'',
          idNumber:'',
          ward_village:'',
          city_union:'',
          district:'',
          state:'',
          locationName:'',
          enterBy:'',
          active:-1,
          totalpages:0,
          page:0

        },
        customLabels:{
          first: '<<',
          last: '>>',
          previous: '<',
          next: '>'
        },
        listError
      }
    },
    components: {
    'simple-pagination': simplePagination,
     'loading': VALoading
     },
    methods: 
 
    {
       ...mapActions([
      'getLanguage'

    ]
       ),
  updateDistrict:function(){
    var self = this.form
    if (self.location.state.length > 0){
      self.state = self.location.state
      self.district = self.location.district
       // alert(self.locationName.state +  '   ' + self.district )
      // this.form.district = 'Azad'
      // alert(this.form.district +  '   ' + self.district)
     }
  },
  getLocations: function(){
    var self = this
    services.Location.getLocation({}) 
    .then(function (response) {
      // console.log(JSON.stringify(response.data))
      self.locationNames = response.data.docs
      // self.search.totalpages = Math.ceil( response.data.count / response.data.perpage )
      // self.search.page = response.data.page
      // self.loading = false 
    })
    .catch(function (error) {
      console.log(error)
    })
  },  
  getRationDistributor: function ( request = {} ) {
    var self = this
    // self.loading = true 
     $('#loadMe').modal('show')
     services.RationDistributor.getRationDistributor(request) 
    .then(function (response) {
      // console.log(JSON.stringify(response.data))
      self.rationdistributors = response.data.docs
      self.search.totalpages = Math.ceil( response.data.count / response.data.perpage )
      self.search.page = response.data.page
      // self.loading = false 
      $('#loadMe').modal('hide')
    })
    .catch(function (error) {
      console.log(error)
    })
  },
  addRationDistributor: function ( request = {} ) {
    var self = this
     self.loading = true 
     services.RationDistributor.addRationDistributor(request) //  .getPatientInfo()
    .then(function (response) {
       self.loading = false
     $('#bsModal').modal('hide')
     $('#loadMe').modal('show')
     self.getRationDistributor({})
    })
    .catch(function (err) {
     self.loading = false 
     self.error = listError(err.response.data)
    })
  },
 updateRationDistributor: function ( request = {} ) {
    var self = this
     self.loading = true
     services.RationDistributor.updateRationDistributor(request) //  .getPatientInfo()
    .then(function (response) {
       self.loading = false
    $('#bsModal').modal('hide')
     $('#loadMe').modal('show')
     self.getRationDistributor({})
    })
    .catch(function (err) {
     self.loading = false
     self.error = listError(err.response.data)
    })
  },
submit:function() {
  if (this.form._id){
    this.updateRationDistributor(this.form)
  } else {
     this.addRationDistributor(this.form)
  }
},
  searchClick: function (){
    this.getRationDistributor(this.search)
  },
  clearClick: function (){
    var self = this // you need this because *this* will refer to Object.keys below
        // Iterate through each object field, key is name of the object field
      Object.keys(this.form).forEach(function(key,index) {
        if (key !== 'totalpages' && key !== 'pages' && key !== 'page'){
          self.search[key] = ''
        }
      })
  },
  pageChange: function (pageNo) {
    var self = this
    self.search.page = pageNo
    this.getRationDistributor(this.search)
  },
  openFrom:function(data){
    this.error = '' 
    if (data){
      this.form = data
    }
    $('#bsModal').modal('show')
  },
 
  
},

 computed: {
    ...mapGetters([
      'lang'
    ])
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.users-list-row{
  margin: 10px;
  padding: 10px;
}
.input-group{
  width: 100%;
  padding: 20px;
}
.input-group-text,.input-group-select{
  width: 10%;
  margin-left: 5px;
}
.input-group-text-small{
 width: 6%;
}
.inlineDiv{
 display: inline;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>

    
    


// WEBPACK FOOTER //
// RationDistributor.vue?7baace55